/**
 * Custom fields reducer
 */

import _merge from "lodash/merge";
import * as actions from "../../actions/actionTypes";
import { cloneDeep, merge } from "lodash";

const fieldsReducer = (state = {}, action) => {
  let fields;
  try {
    fields = action.response.entities.fields;
  } catch (error) {
    // That's ok
  }
  switch (action.type) {
    case actions.UPDATE_CUSTOM_FIELD_SUCCESS: {
      const newField = cloneDeep(action.response.entities.fields[action.response.result]);
      const fieldId = Number(action.response.result);
      return cloneDeep({
        ...state,
        [fieldId]: newField,
      });
    }
    default: {
      if (fields) {
        return merge({}, state, fields);
      }
      return state;
    }
  }
};

export default fieldsReducer;
